const OurTeam = () => {
  const data = [
    {
      name: "Raul",
      description: "Producer",
      avatarurl: "img/discord/Raul.webp",
      link: "https://codefling.com/raul"
    },
    {
      name: "Death",
      description: "Co-Producer",
      avatarurl: "img/discord/Death.webp",
      link: "https://codefling.com/death"
    },
    {
      name: "MalS",
      description: "Moderator",
      avatarurl: "img/discord/MalS.webp",
      link: "https://codefling.com/mals"
    },
    {
      name: "Bubbafett",
      description: "Documentation",
      avatarurl: "img/discord/Bubbafett.webp",
      link: "https://codefling.com/bubbafett"
    },
    {
      name: "Goo",
      description: "Documentation",
      avatarurl: "img/discord/Goo.webp",
      link: "https://codefling.com/goo_"
    },
    {
      name: "Patrette",
      description: "Contributor",
      avatarurl: "img/discord/Patrette.webp",
      link: "https://codefling.com/patrette"
    },
    {
      name: "ThePitereq",
      description: "Contributor",
      avatarurl: "img/discord/ThePitereq.webp",
      link: "https://codefling.com/thepitereq"
    },
    {
      name: "DezLife",
      description: "Contributor",
      avatarurl: "img/discord/DezLife.webp",
      link: "https://codefling.com/dezlife"
    },
    {
      name: "Kulltero",
      description: "Contributor",
      avatarurl: "img/discord/Kultero.webp",
      link: "https://codefling.com/kulltero"
    },
    {
      name: "JakeRich",
      description: "Contributor",
      avatarurl: "img/discord/JakeRich.webp",
      link: "https://github.com/Jake-Rich"
    },
    {
      name: "Grimston",
      description: "Contributor",
      avatarurl: "img/discord/Grimston.webp",
      link: "https://codefling.com/grimston"
    },
    {
      name: "Billy Joe",
      description: "Contributor",
      avatarurl: "img/discord/BillyJoe.webp",
      link: "https://codefling.com/billy-joe"
    },
    {
      name: "Farkas",
      description: "Contributor",
      avatarurl: "img/discord/Farkas.webp",
      link: "https://codefling.com/farkas"
    },
    {
      name: "Kopter",
      description: "Contributor",
      avatarurl: "img/discord/Kopter.webp",
      link: "https://codefling.com/kopter"
    }
  ];

  return (
    <section className="our-team-section">
      <div className="container">
        <h5 className="section-title" data-aos="fade-up">
          OUR TEAM
        </h5>
        <div className="team-wrapper" data-aos="fade-up">
          {data?.map((user, index) => (
            <div className="team-item" key={`team-member` + index}>
              <a href={user.link} target="_blank"><img src={process.env.PUBLIC_URL + "/" + user.avatarurl} alt="" /></a>
              <h6 className="name">{user.name}</h6>
              <span>{user.description}</span><br/>
            </div>
          ))}
        </div>
      </div>
      <img src="/img/ellipsis-team.png" className="team-shape" alt="" />
    </section>
  );
};

export default OurTeam;
